import { NgIf } from '@angular/common';
import { Component, OnInit, Input, Inject, SimpleChanges } from '@angular/core';
import { ItemToCategoryToComponent } from '../../models/item-to-category-to-component';
import { SanitizeHtmlPipe } from '../../pipes/sanitize-html.pipe';

@Component({
    selector: 'pdp-two-column-text-dynamic',
    templateUrl: './two-column-text-dynamic.component.html',
    styleUrls: ['./two-column-text-dynamic.component.scss'],
    imports: [NgIf, SanitizeHtmlPipe],
    standalone: true
})
export class TwoColumnTextDynamicComponent implements OnInit {

  private environment: any;

  @Input()
  public items: ItemToCategoryToComponent[];

  constructor(@Inject('currentEnvironment') environment) {
    this.environment = environment;
  }

  ngOnInit(): void {
  }

  public ngOnChanges(value: SimpleChanges) {
  }
}
